import React from "react";
import { NextPage } from "next";

import PageMap from "scenes/PageMap";

const Index: NextPage = () => <PageMap />;

export default Index;
